import React, { useEffect, useState } from "react";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import { useSelector } from 'react-redux';
import UtilizedBudgetBody from "../DashboardBox/DashboardComponents/UtilizedBudgetBody";
import { UtilizedBudgetOverlayActivity } from "../DashboardBox/DashboardComponents/UtilizedBudgetOverlayActivity";
import { getUtilizedBudget } from "../../helper/Api";

const UtilizedBudgetOverlay = ({
    fy_list, 
    budgetoverlay, 
    setbudgetoverlay, 
    storedGlobalDateId, 
    handleYearDropdown,
    dividerNumber,
    addElipsis,
    formatNumber,
    filterPayload
}) =>{
  const {authData}=useSelector((state)=>state.authData);
  const [activeKeys, setActiveKeys] = useState([]); // Initially open accordions
  const [listview, setListview] = useState(true);
  const [utlizedMonth, setUtilizedMonth] = useState(null);
  const [utilizedBudgetData, setUtilizedBudgetData] = useState([]);
  const [activeUtilizedBudgetChild, setActiveUtilizedBudgetChild] = useState({});
  const [overlayDropDown, setOverlayDropDown] = useState(false);
  const [tableAccordionUtilized, setTableAccordionUtilized] = useState({});
  const [tableChildAccordian, setTableChildAccordian] = useState({});
  const [utilizedActivityAccordian, setutilizedActivityAccordian] = useState({});
  const [utilizedSubActivityAccordian, setutilizedSubActivityAccordian] = useState({});
  const [subheadAccording, setSubheadAccording] = useState({});

    const toggleAccordionUtilized = (index) => {
    setTableAccordionUtilized((prev) => ({
        ...prev,
        [index]: !prev[index],
    }));
    };

    const toggleAccordionChild = (index) => {
        setTableChildAccordian((prev) => ({
        ...prev,
        [index]: !prev[index],
        }));
    };
    const toggleAccordionActivtiy = (index) => {
        setutilizedActivityAccordian((prev) => ({
        ...prev,
        [index]: !prev[index],
        }));
    };
    const toggleAccordionSubActivtiy = (index) => {
        setutilizedSubActivityAccordian((prev) => ({
        ...prev,
        [index]: !prev[index],
        }));
    };

    const toggleSubheadAccordion = (id) => {
    setSubheadAccording((prev) => ({
        ...prev,
        [id]: !prev[id],
    }));
    };

    const toggleAccordion = (key) => {
    setActiveKeys(
        (prevKeys) =>
        prevKeys.includes(key)
            ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
            : [...prevKeys, key] // Add key if it's closed
    );
    };

    const handleButtonClickBudgetChild = (cardId, buttonType) => {
        setActiveUtilizedBudgetChild((prev) => ({
            ...prev,
            [cardId]: prev[cardId] === buttonType ? null : buttonType,
        }));
    };

    const switchHeight = (value) => {
        console.log("m here with", value);
        setSubheadAccording((prev) => !prev);
        };

    useEffect(() => {
    if (utilizedBudgetData?.subheads?.length > 0) {
        const initialState = utilizedBudgetData?.subheads?.reduce(
        (acc, val, index) => {
            acc[val.id] = index == 0 ? "1" : null; // Ensure first subhead is open
            return acc;
        },
        {}
        );

        setActiveUtilizedBudgetChild(initialState);
        console.log("Initial State Set:", initialState); // Debugging log
    }
    }, [utilizedBudgetData]);

    const getUtilizedBudgets = async (fyId) => {
    try {
        const utilizedBudget = await getUtilizedBudget(fyId, utlizedMonth, filterPayload.department_id || authData?.user?.department_id);
        if (utilizedBudget.data.status) {
        setUtilizedBudgetData(utilizedBudget.data.result);
        }
    } catch (error) {
        console.log(error.name);
    }
    };

      const monthArrayValues = [
        {
          month: "April",
          monthNumber: "04",
        },
        {
          month: "May",
          monthNumber: "05",
        },
        {
          month: "June",
          monthNumber: "06",
        },
        {
          month: "July",
          monthNumber: "07",
        },
        {
          month: "August",
          monthNumber: "08",
        },
        {
          month: "September",
          monthNumber: "09",
        },
        {
          month: "October",
          monthNumber: "10",
        },
        {
          month: "November",
          monthNumber: "11",
        },
        {
          month: "December",
          monthNumber: "12",
        },
        {
          month: "January",
          monthNumber: "01",
        },
        {
          month: "February",
          monthNumber: "02",
        },
        {
          month: "March",
          monthNumber: "03",
        },
      ];

      useEffect(() => {
          getUtilizedBudgets(storedGlobalDateId);
        }, [storedGlobalDateId, utlizedMonth, filterPayload?.department_id || authData?.user?.department_id]);
    return (
        <>
             <div className={`overlay ${budgetoverlay ? "d-none" : null}  `}></div>
            
                  <div
                    className={`overlayContent overflow-auto overflow-x-hidden ${
                      budgetoverlay ? "left-100" : null
                    } `}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center p-3 position-sticky top-0 z-3">
                      <div className="fw-600 fs-16px d-flex align-items-center gap-1 ">
                        <i
                          className="icon-close_circle_fill fs-5  cursor-pointer"
                          onClick={() => setbudgetoverlay(true)}
                        ></i>
                        Utilized Budget FY
                        <select
                          name="financial_year_id"
                          onChange={handleYearDropdown}
                          className="bg-transparent border-0 text-white fw-500 fs-16px select"
                          disabled
                        >
                          <option value="" className="text-black">
                            select year
                          </option>
                          {fy_list?.map((fy) => {
                            return (
                              <option
                                value={storedGlobalDateId}
                                key={fy.id}
                                className="text-black"
                                selected={
                                  String(fy.id) === storedGlobalDateId ||
                                  (!storedGlobalDateId &&
                                    fy.start_year === moment().format("YYYY"))
                                }
                              >
                                {fy.year}
                              </option>
                            );
                          })}
                        </select>
                        {listview && (
                          <>
                            |
                            <select
                              name="date"
                              id="date"
                              className="bg-transparent fw-500 fs-16px text-warning-100 border-b-warning-100"
                              onChange={(e) => setUtilizedMonth(e.target.value)}
                            >
                              <option value="" className="text-black">
                                -- Select Month --
                              </option>
                              {monthArrayValues?.map((month) => (
                                <option
                                  value={month.monthNumber}
                                  key={month.monthNumber}
                                  // selected={month === utilizedMonth}
                                >
                                  {month.month}
                                </option>
                              ))}
                            </select>
                          </>
                        )}
                      </div>
                      {/* need to understand code use */}
                      <div className="d-flex gap-2 align-items-center ">
                        <span>
                          As on date{" "}
                          {
                            <select
                              name="financial_year_id"
                              className="bg-transparent border-0 text-white fw-500 fs-16px select"
                              disabled
                            >
                              <option value="" className="text-black">
                                select year
                              </option>
                              {fy_list?.map((fy) => {
                                return (
                                  <option
                                    value={storedGlobalDateId}
                                    key={fy.id}
                                    className="text-black"
                                    selected={
                                      String(fy.id) === storedGlobalDateId ||
                                      (!storedGlobalDateId &&
                                        fy.start_year === moment().format("YYYY"))
                                    }
                                  >
                                    {fy.start_year.includes(new Date().getFullYear())
                                      ? moment().format("Do MMM YYYY")
                                      : "31 Mar " + fy.end_year}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        </span>
                        <i
                          className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
                          onClick={() => setOverlayDropDown((prev) => !prev)}
                        ></i>
            
                        <div
                          className={`position-absolute bg-prime-100 w-100 p-3 ${
                            !overlayDropDown ? "d-none" : "d-inline-block"
                          }`}
                          style={{ top: "100%", zIndex: "10" }}
                        >
                          <div className="d-flex flex-column gap-4">
                            <span className="d-flex align-items-center gap-2">
                              <i className="icon-featured_play_list"></i> Export Excel
                            </span>
                            <span className="d-flex align-items-center gap-2">
                              <i className="icon-picture_as_pdf"></i> Export PDF
                            </span>
                            <span
                              className="d-flex align-items-center gap-2 cursor-pointer"
                              onClick={() => setListview(false)}
                            >
                              <i className="icon-view_list"></i> List View
                            </span>
                            <span
                              className="d-flex align-items-center gap-2 cursor-pointer"
                              onClick={() => setListview(true)}
                            >
                              <i className="icon-grid_on"></i> Grid View
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
            
                    <div className="px-4 py-3 d-flex flex-column gap-2">

                      {!listview === false ? null : (
                        <div className="w-100 overflow-x-auto overflow-y-hidden">
                          <div>
                            {/* =======================heading========================= */}
                            <div
                              className="d-flex justify-content-between text-center"
                              style={{ width: "2000px" }}
                            >
                              <div className="fw-bold border px-1" style={{ width: "25%" }}>
                                Scheme Code/Name
                              </div>
                              <div
                                className="fw-bold border px-1"
                                style={{ width: "25%" }}
                              ></div>
                              <div className="fw-bold border px-1" style={{ width: "25%" }}>
                                Vendor
                              </div>
                              <div className="fw-bold border px-1" style={{ width: "25%" }}>
                                DBT/Nach
                              </div>
                              <div className="fw-bold border px-1" style={{ width: "25%" }}>
                                Salary
                              </div>
                              <div className="fw-bold border px-1" style={{ width: "25%" }}>
                                Child_Allocation
                              </div>
                              <div className="fw-bold border px-1" style={{ width: "25%" }}>
                                Total
                              </div>
                            </div>
            
                            {/* ===========================datas========================= */}
                            <div className="d-flex flex-column gap-1">
                              {utilizedBudgetData?.map((val, ind) => (
                                <div
                                  className="d-flex text-center bg-white flex-column position-relative border-0"
                                  style={
                                    tableAccordionUtilized[val?.id]
                                      ? null
                                      : { height: "77px", width: "2000px" }
                                  }
                                >
                                  <div
                                    className="d-flex bg-white"
                                    style={{ width: "2000px" }}
                                  >
                                    <div className="border" style={{ width: "25%" }}>
                                      {!tableAccordionUtilized[val?.id] ? (
                                        <i
                                          className="icon-arrow_right cursor-pointer"
                                          onClick={() => toggleAccordionUtilized(val?.id)}
                                        ></i>
                                      ) : (
                                        <i
                                          className="icon-arrow_drop_down cursor-pointer"
                                          onClick={() => toggleAccordionUtilized(val?.id)}
                                        ></i>
                                      )}
                                      {addElipsis(val?.code + " | " + val?.name, 20)}
                                    </div>
                                    <div className="" style={{ width: "25%" }}>
                                      <div className="border">Current</div>
                                      <div className="border">Previous</div>
                                      <div className="border">Total</div>
                                    </div>
                                    <div className="" style={{ width: "25%" }}>
                                      <div className="border">{
                                        val?.currentFy?.vendor == 0 ? "-" : formatNumber(val?.currentFy?.vendor / dividerNumber , "indian")  
                                        }</div>
                                      <div className="border">{
                                        val?.prevYear?.vendor == 0 ? "-" : formatNumber(val?.prevYear?.vendor / dividerNumber , "indian")
                                        }</div>
                                      <div className="border">
                                        {
                                          (Number(val?.currentFy?.vendor) +
                                          Number(val?.prevYear?.vendor)) == 0 ? "-" : formatNumber(Number(val?.currentFy?.vendor) + Number(val?.prevYear?.vendor) / dividerNumber , "indian")
                                          }
                                      </div>
                                    </div>
                                    <div className="" style={{ width: "25%" }}>
                                      <div className="border">{
                                        val?.currentFy?.dbt == 0 ? "-" : formatNumber(val?.currentFy?.dbt / dividerNumber , "indian")
                                        }</div>
                                      <div className="border">{
                                        val?.prevYear?.dbt == 0 ? "-" : formatNumber(val?.prevYear?.dbt / dividerNumber , "indian")
                                        }</div>
                                      <div className="border">
                                        {
                                          (Number(val?.currentFy?.dbt) +
                                          Number(val?.prevYear?.dbt)) == 0 ? "-" : formatNumber(Number(val?.currentFy?.dbt) + Number(val?.prevYear?.dbt) / dividerNumber , "indian")
                                          }
                                      </div>
                                    </div>
                                    <div className="" style={{ width: "25%" }}>
                                      <div className="border">-</div>
                                      <div className="border">-</div>
                                      <div className="border">-</div>
                                    </div>
                                    <div className="" style={{ width: "25%" }}>
                                      <div className="border">{
                                        val?.currentFy?.child == 0 ? "-" : formatNumber(val?.currentFy?.child / dividerNumber , "indian")
                                        }</div>
                                      <div className="border">{
                                        val?.prevYear?.child == 0 ? "-" : formatNumber(val?.prevYear?.child / dividerNumber , "indian")
                                        }</div>
                                      <div className="border">
                                        {
                                          (Number(val?.currentFy?.child) +
                                          Number(val?.prevYear?.child)) == 0 ? "-" : formatNumber(Number(val?.currentFy?.child) + Number(val?.prevYear?.child) / dividerNumber , "indian")
                                          }
                                      </div>
                                    </div>
                                    <div className="" style={{ width: "25%" }}>
                                      <div className="border">
                                        {
                                          (Number(val?.currentFy?.vendor) +
                                          Number(val?.currentFy?.dbt) +
                                          Number(val?.currentFy?.child)) == 0 ? "-" : formatNumber(Number(val?.currentFy?.vendor) + Number(val?.currentFy?.dbt) + Number(val?.currentFy?.child) / dividerNumber , "indian")
                                          }
                                      </div>
                                      <div className="border">
                                        {
                                          (Number(val?.prevYear?.vendor) +
                                          Number(val?.prevYear.dbt) +
                                          Number(val?.prevYear.child)) == 0 ? "-" : formatNumber(Number(val?.prevYear?.vendor) + Number(val?.prevYear?.dbt) + Number(val?.prevYear?.child) / dividerNumber , "indian")
                                          }
                                      </div>
                                      <div className="border">
                                        {
                                          (Number(val?.currentFy?.vendor) +
                                          Number(val?.currentFy?.dbt) +
                                          Number(val?.currentFy?.child) +
                                          Number(val?.prevYear?.vendor) +
                                          Number(val?.prevYear.dbt) +
                                          Number(val?.prevYear.child)) == 0 ? "-" : formatNumber(Number(val?.currentFy?.vendor) + Number(val?.currentFy?.dbt) + Number(val?.currentFy?.child) + Number(val?.prevYear?.vendor) + Number(val?.prevYear?.dbt) + Number(val?.prevYear?.child) / dividerNumber , "indian")
                                          }
                                      </div>
                                    </div>
                                  </div>
            
                                  {/* ====================child datas================================== */}
                                  {/* =========subhead======= */}
                                  <div
                                    className="overflow-x-hidden"
                                    style={{
                                      background: "#e6f2ff",
                                      width: "2000px",
                                      height: tableChildAccordian ? null : "auto",
                                    }}
                                  >
                                    <div className="d-flex flex-wrap text-center">
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        {" "}
                                        Sub head
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      ></div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Vendor
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        DBT/Nach
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Salary
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Budget Allocation
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Total
                                      </div>
                                    </div>
                                    {/* ================data================= */}
                                    {val?.subheads?.map((val, ind) => (
                                      <div>
                                        <div className="d-flex border ">
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            {tableChildAccordian[val?.id] ? (
                                              <i
                                                className="icon-arrow_drop_down cursor-pointer"
                                                onClick={() => toggleAccordionChild(val?.id)}
                                              ></i>
                                            ) : (
                                              <i
                                                className="icon-arrow_right cursor-pointer"
                                                onClick={() =>
                                                  toggleAccordionChild(val?.id)
                                                }
                                              ></i>
                                            )}
                                            { addElipsis(val?.name , 15)}
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          ></div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.from_prev_fy?.vendor)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.from_prev_fy?.vendor) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.dbt) +
                                                Number(val?.from_prev_fy?.dbt)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.dbt) + Number(val?.from_prev_fy?.dbt) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            -
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.child) +
                                                Number(val?.from_prev_fy?.child)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.child) + Number(val?.from_prev_fy?.child) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.child) +
                                                Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.child)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.child) + Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.child) / dividerNumber , "indian") 
                                              }
                                          </div>
                                        </div>
                                        {/* ==============================sub child============================== */}
                                        <div
                                          className="d-flex overflow-hidden"
                                          style={{
                                            height: !tableChildAccordian[val?.id] ? "0" : "auto",
                                          }}
                                        >
                                          <div className="border">
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Current
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Previous
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Total
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                val?.current_fy.vendor == 0 ? "-" : formatNumber(val?.current_fy.vendor / dividerNumber , "indian")
                                                }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                val?.from_prev_fy.vendor == 0 ? "-" : formatNumber(val?.from_prev_fy.vendor / dividerNumber , "indian")
                                                }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.from_prev_fy?.vendor)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.from_prev_fy?.vendor) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                val?.current_fy.dbt == 0 ? "-" : formatNumber(val?.current_fy.dbt / dividerNumber , "indian")
                                                }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                val?.from_prev_fy.dbt == 0 ? "-" : formatNumber(val?.from_prev_fy.dbt / dividerNumber , "indian")
                                                }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.dbt) +
                                                Number(val?.from_prev_fy?.dbt)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.dbt) + Number(val?.from_prev_fy?.dbt) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                val?.current_fy.child == 0 ? "-" : formatNumber(val?.current_fy.child / dividerNumber , "indian")
                                                }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                val?.from_prev_fy.child == 0 ? "-" : formatNumber(val?.from_prev_fy.child / dividerNumber , "indian")
                                                }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.child) +
                                                Number(val?.from_prev_fy?.child)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.child) + Number(val?.from_prev_fy?.child) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.child) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.child) / dividerNumber , "indian")
                                              }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.child) ) == 0 ? "-" : formatNumber(Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.child) / dividerNumber , "indian")
                                              }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.child) +
                                                Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.child) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.child) + Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.child) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  {/* ==========================activity=============================== */}
            
                                  <div
                                    className="overflow-x-hidden"
                                    style={{
                                      background: "#cce5ff",
                                      width: "2000px",
                                      height: utilizedActivityAccordian ? null : "auto",
                                    }}
                                  >
                                    <div className="d-flex flex-wrap text-center">
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        {" "}
                                        Activity
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      ></div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Vendor
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        DBT/Nach
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Salary
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Budget Allocation
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Total
                                      </div>
                                    </div>
                                    {/* ================data================= */}
                                    {val?.subheads?.map((val, ind) => (
                                        val?.activities?.map((val, ind)=>(
                                          <div>
                                        <div className="d-flex border ">
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            {utilizedActivityAccordian[val?.activityId] ? (
                                              <i
                                                className="icon-arrow_drop_down cursor-pointer"
                                                onClick={() => toggleAccordionActivtiy(val?.activityId)}
                                              ></i>
                                            ) : (
                                              <i
                                                className="icon-arrow_right cursor-pointer"
                                                onClick={() =>
                                                  toggleAccordionActivtiy(val?.activityId)
                                                }
                                              ></i>
                                            )}
                                            { addElipsis(val?.activityName , 15)}
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          ></div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.from_prev_fy?.vendor)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.from_prev_fy?.vendor) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.dbt) +
                                                Number(val?.from_prev_fy?.dbt)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.dbt) + Number(val?.from_prev_fy?.dbt) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            -
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.budget_allocation)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                          </div>
                                        </div>
                                        {/* ==============================sub child============================== */}
                                        <div
                                          className="d-flex overflow-hidden"
                                          style={{
                                            height: !utilizedActivityAccordian[val?.activityId] ? "0" : "auto",
                                          }}
                                        >
                                          <div className="border">
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Current
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Previous
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Total
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.current_fy.vendor == 0 ? "-" : formatNumber(val?.current_fy.vendor / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.from_prev_fy.vendor == 0 ? "-" : formatNumber(val?.from_prev_fy.vendor / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.from_prev_fy?.vendor)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.from_prev_fy?.vendor) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.current_fy.dbt == 0 ? "-" : formatNumber(val?.current_fy.dbt / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.from_prev_fy.dbt == 0 ? "-" : formatNumber(val?.from_prev_fy.dbt / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.dbt) +
                                                Number(val?.from_prev_fy?.dbt)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.dbt) + Number(val?.from_prev_fy?.dbt) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.current_fy?.budget_allocation == 0 ? "-" : formatNumber(val?.current_fy?.budget_allocation / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.from_prev_fy?.budget_allocation == 0 ? "-" : formatNumber(val?.from_prev_fy?.budget_allocation / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.budget_allocation)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.budget_allocation)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian") 
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                        ))
            
                                    ))}
                                  </div>
            
            
            
                                  {/* =======sub activity=== */}
                                  <div
                                    className="overflow-x-hidden"
                                    style={{
                                      background: "#b3d7ff",
                                      width: "2000px",
                                      height: utilizedSubActivityAccordian ? null : "auto",
                                    }}
                                  >
                                    <div className="d-flex flex-wrap text-center">
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Sub Activity
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      ></div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Vendor
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        DBT/Nach
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Salary
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Budget Allocation
                                      </div>
                                      <div
                                        className="fw-bold border px-1"
                                        style={{ width: "200px" }}
                                      >
                                        Total
                                      </div>
                                    </div>
                                    {/* ================data================= */}
                                    {val?.subheads?.map((val, ind) => (
                                      val?.subactivities?.map((val, ind)=>(
                                        <div>
                                        <div className="d-flex border ">
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            {utilizedSubActivityAccordian[val?.subactivityId] ? (
                                              <i
                                                className="icon-arrow_drop_down cursor-pointer"
                                                onClick={() => toggleAccordionSubActivtiy(val?.subactivityId)}
                                              ></i>
                                            ) : (
                                              <i
                                                className="icon-arrow_right cursor-pointer"
                                                onClick={() =>
                                                  toggleAccordionSubActivtiy(val?.subactivityId)
                                                }
                                              ></i>
                                            )}
                                            { addElipsis(val?.subactivityName , 15)}
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          ></div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.from_prev_fy?.vendor)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.from_prev_fy?.vendor) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.dbt) +
                                                Number(val?.from_prev_fy?.dbt)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.dbt) + Number(val?.from_prev_fy?.dbt) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            -
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                             {
                                                (Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.budget_allocation)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                          </div>
                                          <div
                                            className="border p-1"
                                            style={{ width: "200px" }}
                                          >
                                            {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                          </div>
                                        </div>
                                        {/* ==============================sub child============================== */}
                                        <div
                                          className="d-flex overflow-hidden"
                                          style={{
                                            height: !utilizedSubActivityAccordian[val?.subactivityId] ? "0" : "auto",
                                          }}
                                        >
                                          <div className="border">
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                            <div
                                              className=""
                                              style={{ width: "200px" }}
                                            ></div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Current
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Previous
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              Total
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.current_fy.vendor == 0 ? "-" : formatNumber(val?.current_fy.vendor / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.from_prev_fy.vendor == 0 ? "-" : formatNumber(val?.from_prev_fy.vendor / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.from_prev_fy?.vendor)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.from_prev_fy?.vendor) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.current_fy.dbt == 0 ? "-" : formatNumber(val?.current_fy.dbt / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.from_prev_fy.dbt == 0 ? "-" : formatNumber(val?.from_prev_fy.dbt / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.dbt) +
                                                Number(val?.from_prev_fy?.dbt)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.dbt) + Number(val?.from_prev_fy?.dbt) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              -
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.current_fy.budget_allocation == 0 ? "-" : formatNumber(val?.current_fy.budget_allocation / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {val?.from_prev_fy.budget_allocation == 0 ? "-" : formatNumber(val?.from_prev_fy.budget_allocation / dividerNumber , "indian")}
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.budget_allocation)) == 0 ? "-" : formatNumber(Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                          <div className="border">
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                            <div
                                              className="border p-1"
                                              style={{ width: "200px" }}
                                            >
                                              {
                                                (Number(val?.current_fy?.vendor) +
                                                Number(val?.current_fy?.dbt) +
                                                Number(val?.current_fy?.budget_allocation) +
                                                Number(val?.from_prev_fy?.vendor) +
                                                Number(val?.from_prev_fy?.dbt) +
                                                Number(val?.from_prev_fy?.budget_allocation) ) == 0 ? "-" : formatNumber(Number(val?.current_fy?.vendor) + Number(val?.current_fy?.dbt) + Number(val?.current_fy?.budget_allocation) + Number(val?.from_prev_fy?.vendor) + Number(val?.from_prev_fy?.dbt) + Number(val?.from_prev_fy?.budget_allocation) / dividerNumber , "indian")
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      ))
             
                                    ))}
                                  </div>
            
            
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ======================== card view utilized budget ========================== */}
            
                      {listview &&
                        utilizedBudgetData?.map((val, ind) => (
                          <div
                            className="bg-white border-Prime-100 "
                            style={{ borderRadius: "8px" }}
                            key={val?.id}
                          >
                            <div
                              className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden"
                              style={{ borderRadius: "8px 8px 0 0" }}
                            >
                              {/* ======================card header================== */}
                              <span
                                className="fs-14px white-space-nowrap overflow-x-hidden"
                                style={{ width: "95%", fontStyle: "italic" }}
                              >
                                {/* =======================card header====================== */}
                                <span
                                  className="fs-14px white-space-nowrap overflow-x-hidden "
                                  style={{ width: "95%", fontStyle: "italic" }}
                                >
                                  {val?.code}- {val?.name}
                                </span>
                              </span>
            
                              <span>
                                <i className="icon-remove_red_eye cursor-pointer"></i>
                              </span>
                            </div>
            
                            {/* ================== card body ========================= */}
                            {/* modification required in quartly data */}
                            <div className="row py-2 px-3">
                              <div className="col-3 px-2">
                                <div className="border border-primary rounded-2 p-1">
                                  <div className="fs-12px text-black-60 p-1">Quarter 1</div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "04" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">April</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[0]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[0]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "05" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">May</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[1]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[1]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "06" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">June</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[2]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[2]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center p-1 bg-success-20">
                                    <span className="fw-500 fs-14px">Total</span>
                                    <span className="fw-500 fs-14px text-success-100">
                                      {Number(val?.monthlyData?.[0]?.amount) +
                                        Number(val?.monthlyData?.[1]?.amount) +
                                        Number(val?.monthlyData?.[2]?.amount) ==
                                      0
                                        ? "-"
                                        : formatNumber(
                                            (Number(val?.monthlyData?.[0]?.amount) +
                                              Number(val?.monthlyData?.[1]?.amount) +
                                              Number(val?.monthlyData?.[2]?.amount)) /
                                              dividerNumber,
                                            "india"
                                          )}
                                    </span>
                                  </div>
                                </div>
                              </div>
            
                              <div className="col-3 px-2">
                                <div className="border border-primary rounded-2 p-1">
                                  <div className="fs-12px text-black-60 p-1">Quarter 2</div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "07" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">July</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[3]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[3]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "08" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">August</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[4]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[4]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "09" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">September</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[5]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[5]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center p-1 bg-success-20">
                                    <span className="fw-500 fs-14px">Total</span>
                                    <span className="fw-500 fs-14px text-success-100">
                                      {Number(val?.monthlyData?.[3]?.amount) +
                                        Number(val?.monthlyData?.[4]?.amount) +
                                        Number(val?.monthlyData?.[5]?.amount) ==
                                      0
                                        ? "-"
                                        : formatNumber(
                                            (Number(val?.monthlyData?.[3]?.amount) +
                                              Number(val?.monthlyData?.[4]?.amount) +
                                              Number(val?.monthlyData?.[5]?.amount)) /
                                              dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                </div>
                              </div>
            
                              <div className="col-3 px-2">
                                <div className="border border-primary rounded-2 p-1">
                                  <div className="fs-12px text-black-60 p-1">Quarter 3</div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "10" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">October</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[6]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[6]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "11" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">November</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[7]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[7]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "12" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">December</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[8]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[8]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center p-1 bg-success-20">
                                    <span className="fw-500 fs-14px">Total</span>
                                    <span className="fw-500 fs-14px text-success-100">
                                      {Number(val?.monthlyData?.[6]?.amount) +
                                        Number(val?.monthlyData?.[7]?.amount) +
                                        Number(val?.monthlyData?.[8]?.amount) ==
                                      0
                                        ? "-"
                                        : formatNumber(
                                            (Number(val?.monthlyData?.[6]?.amount) +
                                              Number(val?.monthlyData?.[7]?.amount) +
                                              Number(val?.monthlyData?.[8]?.amount)) /
                                              dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                </div>
                              </div>
            
                              <div className="col-3 px-2">
                                <div className="border border-primary rounded-2 p-1">
                                  <div className="fs-12px text-black-60 p-1">Quarter 4</div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "01" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">January</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[9]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[9]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "02" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">February</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[10]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[10]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center p-1 ${
                                      utlizedMonth == "03" && "bg-secondary-20"
                                    } `}
                                  >
                                    <span className="fw-500 fs-14px">March</span>
                                    <span className="fw-500 fs-14px">
                                      {val?.monthlyData[11]?.amount == 0
                                        ? "-"
                                        : formatNumber(
                                            val?.monthlyData[11]?.amount / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center p-1 bg-success-20">
                                    <span className="fw-500 fs-14px">Total</span>
                                    <span className="fw-500 fs-14px text-success-100">
                                      {Number(val?.monthlyData?.[9]?.amount) +
                                        Number(val?.monthlyData?.[10]?.amount) +
                                        Number(val?.monthlyData?.[11]?.amount) ==
                                      0
                                        ? "-"
                                        : formatNumber(
                                            (Number(val?.monthlyData?.[9]?.amount) +
                                              Number(val?.monthlyData?.[10]?.amount) +
                                              Number(val?.monthlyData?.[11]?.amount)) /
                                              dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
            
                            <div className="py-2 px-3">
                              <div className="row fs-12px text-black-60 p-1">
                                <div className="col-2"></div>
                                <div className="col-2">Vendor</div>
                                <div className="col-2">DBT/Nach</div>
                                <div className="col-2">Salary</div>
                                <div className="col-2">Budget Allocation</div>
                                <div className="col-2">Total</div>
                              </div>
                              <div className="row fs-14px p-1 fw-500">
                                <div className="col-2 text-prime-100 fs-12px">
                                  FY {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                                </div>
                                <div className="col-2">
                                  {val?.currentFy?.vendor == 0
                                    ? "-"
                                    : formatNumber(
                                        val?.currentFy?.vendor / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2">
                                  {val?.currentFy?.dbt == 0
                                    ? "-"
                                    : formatNumber(
                                        val?.currentFy?.dbt / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2">-</div>
                                <div className="col-2">
                                  {val?.currentFy?.child == 0
                                    ? "-"
                                    : formatNumber(
                                        val?.currentFy?.child / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2 text-success-100">
                                  {Number(val?.currentFy?.vendor) +
                                    Number(val?.currentFy?.dbt) +
                                    Number(val?.currentFy?.child) ==
                                  0
                                    ? "-"
                                    : formatNumber(
                                        Number(
                                          val?.currentFy?.vendor +
                                            Number(val?.currentFy?.dbt) +
                                            Number(val?.currentFy?.child)
                                        ) / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                              </div>
                              <div className="row fs-14px p-1 fw-500">
                                <div className="col-2 text-prime-100 fs-12px">
                                  Previous Year Balance
                                </div>
                                <div className="col-2">
                                  {val?.prevYear?.vendor == 0
                                    ? "-"
                                    : formatNumber(
                                        val?.prevYear?.vendor / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2">
                                  {val?.prevYear?.dbt == 0
                                    ? "-"
                                    : formatNumber(
                                        val?.prevYear?.dbt / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2">-</div>
                                <div className="col-2">
                                  {val?.prevYear?.child == 0
                                    ? "-"
                                    : formatNumber(
                                        val?.prevYear?.child / dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2 text-success-100">
                                  {Number(val?.prevYear?.vendor) +
                                    Number(val?.prevYear?.dbt) +
                                    Number(val?.prevYear?.child) ==
                                  0
                                    ? "-"
                                    : formatNumber(
                                        (Number(val?.prevYear?.vendor) +
                                          Number(val?.prevYear?.dbt) +
                                          Number(val?.prevYear?.child)) /
                                          dividerNumber,
                                        "indian"
                                      )}
                                </div>
                              </div>
                              <div className="row fs-14px bg-info-20 py-1 px-1 fw-500">
                                <div className="col-2 text-prime-100 fs-12px">Total</div>
                                <div className="col-2">
                                  {Number(val?.currentFy?.vendor) +
                                    Number(val?.prevYear?.vendor) ==
                                  0
                                    ? "-"
                                    : formatNumber(
                                        (Number(val?.currentFy?.vendor) +
                                          Number(val?.prevYear?.vendor)) /
                                          dividerNumber,
                                        "indian"
                                      )}
                                </div>
            
                                <div className="col-2">
                                  {Number(val?.currentFy?.dbt) +
                                    Number(val?.prevYear?.dbt) ==
                                  0
                                    ? "-"
                                    : formatNumber(
                                        (Number(val?.currentFy?.dbt) +
                                          Number(val?.prevYear?.dbt)) /
                                          dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2">-</div>
                                <div className="col-2">
                                  {Number(val?.currentFy?.child) +
                                    Number(val?.prevYear?.child) ==
                                  0
                                    ? "-"
                                    : formatNumber(
                                        (Number(val?.currentFy?.child) +
                                          Number(val?.prevYear?.child)) /
                                          dividerNumber,
                                        "indian"
                                      )}
                                </div>
                                <div className="col-2 text-success-100">
                                  {Number(val?.currentFy?.vendor) +
                                    Number(val?.currentFy?.dbt) +
                                    Number(val?.currentFy?.child) +
                                    Number(val?.prevYear?.vendor) +
                                    Number(val?.prevYear?.dbt) +
                                    Number(val?.prevYear?.child) ==
                                  0
                                    ? "-"
                                    : formatNumber(
                                        (Number(val?.currentFy?.vendor) +
                                          Number(val?.currentFy?.dbt) +
                                          Number(val?.currentFy?.child) +
                                          Number(val?.prevYear?.vendor) +
                                          Number(val?.prevYear?.dbt) +
                                          Number(val?.prevYear?.child)) /
                                          dividerNumber,
                                        "indian"
                                      )}
                                </div>
                              </div>
            
                              {/* ===================card footer ==================== */}
                              <div className="border mx-2 mt-2"></div>
            
                              {/* =======================buttons ====================== */}
            
                              <div className="p-2 d-flex justify-content-between text-secondary-50 px-4">
                                <button
                                  onClick={() => handleButtonClickBudgetChild(val?.id, "1")}
                                  className={` ${
                                    activeUtilizedBudgetChild[val?.id] == 1
                                      ? "bg-secondary-20"
                                      : "bg-white"
                                  }  border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4`}
                                >
                                  {activeUtilizedBudgetChild[val?.id] == 1 ? (
                                    <i className="icon-remove_circle_outline"></i>
                                  ) : (
                                    <i className="icon-add_circle_outline"></i>
                                  )}
                                  Sub head
                                </button>
            
                                {val?.is_activity_active && (
                                  <>
                                    <button
                                      onClick={() =>
                                        handleButtonClickBudgetChild(val?.id, "2")
                                      }
                                      className={`${
                                        activeUtilizedBudgetChild[val?.id] == 2
                                          ? "bg-secondary-20"
                                          : "bg-white"
                                      } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                    >
                                      {activeUtilizedBudgetChild[val?.id] == 2 ? (
                                        <i className="icon-remove_circle_outline"></i>
                                      ) : (
                                        <i className="icon-add_circle_outline"></i>
                                      )}
                                      Activity
                                    </button>
            
                                    <button
                                      onClick={() =>
                                        handleButtonClickBudgetChild(val?.id, "3")
                                      }
                                      className={`${
                                        activeUtilizedBudgetChild[val?.id] == 3
                                          ? "bg-secondary-20"
                                          : "bg-white"
                                      } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                    >
                                      {activeUtilizedBudgetChild[val?.id] == 3 ? (
                                        <i className="icon-remove_circle_outline"></i>
                                      ) : (
                                        <i className="icon-add_circle_outline"></i>
                                      )}
                                      Sub-Activity
                                    </button>
                                  </>
                                )}
                              </div>
            
                              {/* ==============================subhead data================================ */}
                              {activeUtilizedBudgetChild[val?.id] == "1" && (
                                <div className="row fs-12px text-black-60 p-1 mt-1">
                                  <div className="col-2">Sub Head </div>
                                  <div className="col-2">Vendor</div>
                                  <div className="col-2">DBT/Nach</div>
                                  <div className="col-2">Salary</div>
                                  <div className="col-2">Budget Allocation</div>
                                  <div className="col-2">Total</div>
                                </div>
                              )}
            
                              {activeUtilizedBudgetChild[val?.id] == "1" &&
                                val?.subheads?.map((vals, ind) => (
                                  <div key={vals?.id}>
                                    <div
                                      className="row fs-14px p-1 fw-500 overflow-hidden"
                                      style={{
                                        background: ind % 2 == 0 ? "#F8F8F8" : "#FFFFFF",
                                        height: subheadAccording[vals.id]
                                          ? "fit-content"
                                          : "35px",
                                      }}
                                    >
                                      <div className="col-2 d-flex align-items-center">
                                        {!subheadAccording[vals.id] ? (
                                          <i
                                            className="icon-keyboard_arrow_right
                                           cursor-pointer"
                                            onClick={() => toggleSubheadAccordion(vals?.id)}
                                          ></i>
                                        ) : (
                                          <i
                                            className="icon-keyboard_arrow_down cursor-pointer"
                                            onClick={() => toggleSubheadAccordion(vals?.id)}
                                          ></i>
                                        )}
            
                                        <span>{addElipsis(vals?.name, 13)}</span>
                                      </div>
                                      <div className="col-2">
                                        {Number(vals?.current_fy?.vendor) +
                                          Number(vals.from_prev_fy?.vendor) ==
                                        0
                                          ? "-"
                                          : formatNumber(
                                              (Number(vals?.current_fy?.vendor) +
                                                Number(vals.from_prev_fy?.vendor)) /
                                                dividerNumber,
                                              "indian"
                                            )}
                                      </div>
            
                                      <div className="col-2">
                                        {Number(vals.current_fy?.dbt) +
                                          Number(vals.from_prev_fy?.dbt) ==
                                        0
                                          ? "-"
                                          : formatNumber(
                                              (Number(vals.current_fy?.dbt) +
                                                Number(vals.from_prev_fy?.dbt)) /
                                                dividerNumber,
                                              "indian"
                                            )}
                                      </div>
            
                                      <div className="col-2">-</div>
                                      <div className="col-2">
                                        {Number(vals?.current_fy?.child) +
                                          Number(vals?.from_prev_fy?.child) ==
                                        0
                                          ? "-"
                                          : formatNumber(
                                              (Number(vals?.current_fy?.child) +
                                                Number(vals?.from_prev_fy?.child)) /
                                                dividerNumber,
                                              "indian"
                                            )}
                                      </div>
            
                                      <div className="col-2 text-success-100">
                                        {Number(vals?.current_fy?.vendor) +
                                          Number(vals?.current_fy?.dbt) +
                                          Number(vals?.current_fy?.child) +
                                          Number(vals?.from_prev_fy?.vendor) +
                                          Number(vals?.from_prev_fy?.dbt) +
                                          Number(vals?.from_prev_fy?.child) ==
                                        0
                                          ? "-"
                                          : formatNumber(
                                              (Number(vals?.current_fy?.vendor) +
                                                Number(vals?.current_fy?.dbt) +
                                                Number(vals?.current_fy?.child) +
                                                Number(vals?.from_prev_fy?.vendor) +
                                                Number(vals?.from_prev_fy?.dbt) +
                                                Number(vals?.from_prev_fy?.child)) /
                                                dividerNumber,
                                              "indian"
                                            )}
                                      </div>
                                      <div className="mt-1">
                                        <div className="row fs-14px p-1 fw-500">
                                          <div className="col-2 text-prime-100 fs-12px">
                                            FY {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                                          </div>
                                          <div className="col-2">
                                            {vals?.current_fy?.vendor == 0
                                              ? "-"
                                              : formatNumber(
                                                  vals?.current_fy?.vendor / dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                          <div className="col-2">
                                            {vals.current_fy?.dbt == 0
                                              ? "-"
                                              : formatNumber(
                                                  vals.current_fy?.dbt / dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                          <div className="col-2">-</div>
                                          <div className="col-2">
                                            {vals?.current_fy?.child == 0
                                              ? "-"
                                              : formatNumber(
                                                  vals?.current_fy?.child / dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                          <div className="col-2 text-success-100">
                                            {Number(vals?.current_fy?.vendor) +
                                              Number(vals?.current_fy?.dbt) +
                                              Number(vals?.current_fy?.child) ==
                                            0
                                              ? "-"
                                              : formatNumber(
                                                  (Number(vals?.current_fy?.vendor) +
                                                    Number(vals?.current_fy?.dbt) +
                                                    Number(vals?.current_fy?.child)) /
                                                    dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                        </div>
                                        {/* =======================previous year balance =================== */}
                                        <div className="row fs-14px p-1 fw-500">
                                          <div className="col-2 text-prime-100 fs-12px">
                                            Previous Year Balance
                                          </div>
                                          <div className="col-2">
                                            {vals?.from_prev_fy?.vendor == 0
                                              ? "-"
                                              : formatNumber(
                                                  vals?.from_prev_fy?.vendor /
                                                    dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                          <div className="col-2">
                                            {vals?.from_prev_fy?.dbt == 0
                                              ? "-"
                                              : formatNumber(
                                                  vals?.from_prev_fy?.dbt / dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                          <div className="col-2">-</div>
                                          <div className="col-2">
                                            {vals?.from_prev_fy?.child == 0
                                              ? "-"
                                              : formatNumber(
                                                  vals?.from_prev_fy?.child / dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                          <div className="col-2 text-success-100">
                                            {formatNumber(
                                              Number(vals?.from_prev_fy?.vendor) +
                                                Number(vals?.from_prev_fy?.dbt) +
                                                Number(vals?.from_prev_fy?.child)
                                            ) == 0
                                              ? "-"
                                              : formatNumber(
                                                  (Number(vals?.from_prev_fy?.vendor) +
                                                    Number(vals?.from_prev_fy?.dbt) +
                                                    Number(vals?.from_prev_fy?.child)) /
                                                    dividerNumber,
                                                  "indian"
                                                )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              {activeUtilizedBudgetChild[val?.id] == "1" && (
                                <div className="row fs-14px bg-info-20 py-1 px-1 fw-500">
                                  <div className="col-2 text-prime-100 fs-12px">Total</div>
                                  <div className="col-2">
                                    {Number(val?.currentFy?.vendor) +
                                      Number(val?.prevYear?.vendor) ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (Number(val?.currentFy?.vendor) +
                                            Number(val?.prevYear?.vendor)) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
            
                                  <div className="col-2">
                                    {Number(val?.currentFy?.dbt) +
                                      Number(val?.prevYear?.dbt) ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (Number(val?.currentFy?.dbt) +
                                            Number(val?.prevYear?.dbt)) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                  <div className="col-2">-</div>
                                  <div className="col-2">
                                    {Number(val?.currentFy?.child) +
                                      Number(val?.prevYear?.child) ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (Number(val?.currentFy?.child) +
                                            Number(val?.prevYear?.child)) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                  <div className="col-2 text-success-100">
                                    {Number(val?.currentFy?.vendor) +
                                      Number(val?.currentFy?.dbt) +
                                      Number(val?.currentFy?.child) +
                                      Number(val?.prevYear?.vendor) +
                                      Number(val?.prevYear?.dbt) +
                                      Number(val?.prevYear?.child) ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (Number(val?.currentFy?.vendor) +
                                            Number(val?.currentFy?.dbt) +
                                            Number(val?.currentFy?.child) +
                                            Number(val?.prevYear?.vendor) +
                                            Number(val?.prevYear?.dbt) +
                                            Number(val?.prevYear?.child)) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                </div>
                              )}
            
                              {/* ==============================utilizedBudget Fy activity ============================== */}
            
                              <div className="d-flex flex-column gap-1 w-100" key={val?.id}>
                                {activeUtilizedBudgetChild[val?.id] == "2" &&
                                  val?.subheads?.map((val, ind) => (
                                    <Accordion
                                      activeKey={activeKeys}
                                      style={{ border: "0" }}
                                    >
                                      <Accordion.Item
                                        eventKey={val?.id}
                                        style={{ borderRadius: "0", border: "0" }}
                                      >
                                        <Accordion.Header
                                          onClick={() => toggleAccordion(val?.id)}
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            position: "relative",
                                            borderRadius: "0",
                                          }}
                                        >
                                          <div className="w-100 d-flex justify-content-between">
                                            <span>{val?.name}</span>
                                            <span
                                              className="d-flex justify-content-center align-items-center bg-success-100  text-white rounded-circle"
                                              style={{
                                                height: "13.33px",
                                                width: "13.33px",
                                              }}
                                            >
                                              {activeKeys.includes(val?.id) ? "-" : "+"}
                                            </span>
                                          </div>
                                        </Accordion.Header>
                                        <UtilizedBudgetOverlayActivity
                                          fy_list={fy_list}
                                          setSubheadAccording={switchHeight}
                                          subheadAccording={subheadAccording}
                                          storedGlobalDateId={storedGlobalDateId}
                                          activities={val?.activities}
                                          addElipsis={addElipsis}
                                          formatNumber={formatNumber}
                                        />
                                      </Accordion.Item>
                                    </Accordion>
                                  ))}
                              </div>
                              {/* ==============================utilizedBudget Fy sub-activity ============================== */}
            
                              {activeUtilizedBudgetChild[val?.id] == "3" && (
                                <div className="d-flex flex-column gap-1">
                                  {val?.subheads?.map((subActivity, ind) =>
                                    subActivity?.activities?.map((val, ind) => (
                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey={val?.activityId}
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion(val?.activityId)}
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              position: "relative",
                                              borderRadius: "0",
                                            }}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>
                                                {" "}
                                                {subActivity?.name} | {val?.activityName}
                                              </span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes(val?.activityId)
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>
            
                                          <Accordion.Body className="p-2">
                                            <div className="row fs-12px text-black-60 p-1">
                                              <div className="col-2">Sub Activity</div>
                                              <div className="col-2">Vendor</div>
                                              <div className="col-2">DBT</div>
                                              <div className="col-2">Salary</div>
                                              <div className="col-2">Budget Allocation</div>
                                              <div className="col-2">Total</div>
                                            </div>
            
                                            <UtilizedBudgetBody
                                              subActivity={subActivity?.subactivities}
                                              subheadAccording={subheadAccording}
                                              setSubheadAccording={setSubheadAccording}
                                              fy_list={fy_list}
                                              storedGlobalDateId={storedGlobalDateId}
                                              addElipsis={addElipsis}
                                              formatNumber={formatNumber}
                                              activityId={val?.activityId}
                                            ></UtilizedBudgetBody>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                    ))
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
        </>
    )
}

export default UtilizedBudgetOverlay;